class SliderPress extends HTMLElement {
  constructor() {
    super();

    this.mainSliderElement = this.querySelector("[data-slider-main]");
    this.thumbsSliderElement = this.querySelector("[data-slider-thumbs]");
    this.thumbsSlidesCount = Number(
      this.thumbsSliderElement?.dataset?.slidesCount || 0
    );
    // מגדיר את הלינק של הלוגו מתוך אטריביוט 'logo-link' 
    this.logoLink = this.getAttribute('logo-link') || '#'; 

    if (this.mainSliderElement && this.thumbsSliderElement) {
      this.mainSlider = new Swiper(this.mainSliderElement, {
        slidesPerView: 1,
      });

      this.thumbsSlider = new Swiper(this.thumbsSliderElement, {
        slidesPerView: this.thumbsSlidesCount,
        spaceBetween: 10,
        breakpoints: {
          990: {
            slidesPerView: 1,
          },
          1200: {
            slidesPerView: this.thumbsSlidesCount >= 2 ? 2 : this.thumbsSlidesCount,
            spaceBetween: 0,
          }
        },
      });
    }

    this.addEventListener('click', this.openLogoLink); // הפונקציה שפותחת את הלינק בטאב חדש
  }

  openLogoLink() {
    // אם הלינק לא ריק, פותח אותו בטאב חדש
    if (this.logoLink && this.logoLink !== '#') {
      window.open(this.logoLink, '_blank'); 
    }
  }
}

customElements.define("slider-press", SliderPress);
